import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["offerLoadingOverlay", "additionalFundsToggle", "additionalFundsToggleLabel"];
  static values = { cashoutIncludedOfferPath: String, cashoutExcludedOfferPath: String };

  toggleOffer = async (event) => {
    const included = event.target.checked;
    const url = included ? this.cashoutIncludedOfferPathValue : this.cashoutExcludedOfferPathValue;

    this.offerLoadingOverlayTargets.forEach(el => el.classList.remove("hidden"));
    this.additionalFundsToggleTarget.disabled = true;
    this.additionalFundsToggleLabelTarget.classList.add("pointer-events-none");

    try {
      await get(url, { responseKind: "turbo-stream" });
    } catch (err) {
      Turbo.visit(url);
    } finally {
      this.offerLoadingOverlayTargets.forEach(el => el.classList.add("hidden"));
      if (this.hasAdditionalFundsToggleTarget) this.additionalFundsToggleTarget.disabled = false;
      if (this.hasAdditionalFundsToggleLabelTarget) this.additionalFundsToggleLabelTarget.classList.remove("pointer-events-none");
    }
  }
}
